export enum AcquisitionYieldEnum {
  GROSS_INITIAL_YIELD = 'GrossInitialYield',
  NET_INITIAL_YIELD = 'NetInitialYield',
  YIELD_ON_COST = 'Yield-On-Cost',
}
